import React from 'react';
import {
  Create,
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  BooleanInput,
  SelectInput,
  ReferenceInput,
  AutocompleteInput,
  useRecordContext,
} from 'react-admin';

const kycStatusChoices = [
  { id: 'unverified', name: 'Unverified' },
  { id: 'in_review', name: 'In Review' },
  { id: 'verified', name: 'Verified' },
];

// ---------- ছবি প্রিভিউ (শুধু দেখার জন্য) ----------
const KycImagePreview = ({ source, label }) => {
  const record = useRecordContext();
  const url = record && record[source];
  return (
    <div style={{ marginBottom: 16 }}>
      <p style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>{label}</p>
      {url ? (
        <img
          src={url}
          alt={label}
          style={{ maxWidth: 300, maxHeight: 300, borderRadius: 4, display: 'block' }}
        />
      ) : (
        <p style={{ fontSize: 13, color: '#666' }}>কোনো ছবি সাবমিট করা হয়নি</p>
      )}
    </div>
  );
};

// ---------- ভিডিও/ফাইল প্রিভিউ (শুধু দেখার জন্য) ----------
const KycFacePreview = ({ source, label }) => {
  const record = useRecordContext();
  const url = record && record[source];
  const lower = url ? url.toLowerCase() : '';
  const isVideo = /webm|mp4|mov|mkv|ogg/.test(lower);
  const [videoError, setVideoError] = React.useState(false);

  return (
    <div style={{ marginBottom: 16 }}>
      <p style={{ fontSize: 12, color: '#888', marginBottom: 4 }}>{label}</p>

      {!url && <p style={{ fontSize: 13, color: '#666' }}>কোনো ফাইল সাবমিট করা হয়নি</p>}

      {url && isVideo && !videoError && (
        <video
          src={url}
          controls
          style={{ maxWidth: 300, maxHeight: 300, display: 'block' }}
          onError={() => setVideoError(true)}
        />
      )}

      {url && (!isVideo || videoError) && (
        <a href={url} target="_blank" rel="noreferrer" style={{ fontSize: 13 }}>
          {videoError ? 'ভিডিও প্লে করা যাচ্ছে না — এখানে ক্লিক করে দেখুন' : 'ফাইল দেখুন'}
        </a>
      )}
    </div>
  );
};

export const AgentCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ReferenceInput source="user" reference="users">
        <AutocompleteInput label="User" optionText="username" />
      </ReferenceInput>

      <TextInput source="display_name" label="Display name" isRequired />
      <TextInput source="phone_number" label="Phone number" />
      <TextInput source="manager_whatsapp_link" label="Manager whatsapp link" />
      <TextInput source="manager_telegram_link" label="Manager telegram link" />
      <BooleanInput source="is_active" label="Is active" defaultValue={true} />
      <NumberInput source="deposit_limit_total" label="Deposit limit total" defaultValue={0} />
      <NumberInput source="commission_percent" label="Commission percent" defaultValue={0} />
      <NumberInput source="commission_balance" label="Commission balance" defaultValue={0} />
      <SelectInput source="kyc_status" label="Kyc status" choices={kycStatusChoices} defaultValue="unverified" />
    </SimpleForm>
  </Create>
);

export const AgentEdit = (props) => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="display_name" label="Display name" />
      <TextInput source="phone_number" label="Phone number" />
      <TextInput source="manager_whatsapp_link" label="Manager whatsapp link" />
      <TextInput source="manager_telegram_link" label="Manager telegram link" />
      <BooleanInput source="is_active" label="Is active" />
      <NumberInput source="deposit_limit_total" label="Deposit limit total" />
      <NumberInput source="commission_percent" label="Commission percent" />
      <NumberInput source="commission_balance" label="Commission balance" />
      <SelectInput source="kyc_status" label="Kyc status" choices={kycStatusChoices} />

      <KycImagePreview source="kyc_nid_front" label="Kyc nid front" />
      <KycImagePreview source="kyc_nid_back" label="Kyc nid back" />
      <KycFacePreview source="kyc_face_capture" label="Kyc face capture" />

      <TextInput source="kyc_rejection_reason" label="Kyc rejection reason" multiline />
    </SimpleForm>
  </Edit>
);